import { Tokens } from '@/assets/tokens'
import styled, { css, keyframes } from 'styled-components'

export const FilterGroup = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
  width: 100%;
  border-radius: ${Tokens.RadiusInput};
`

export const FilterContainer = styled.div`
  background-color: white;
  align-items: center;
  border-radius: ${Tokens.RadiusInput};
  width: 100%;
  padding: 1rem;
`

const hideTransition = keyframes`
  from {
    opacity: 1;
    visibility: visible;
    max-height: auto;
  }
  to {
    opacity: 0;
    visibility: hidden;
    max-height: 0;
  }
`

const showTransition = keyframes`
  from {
    opacity: 0;
    max-height: 0;
  }
  to {
    opacity: 1;
    max-height: auto;
  }
`

export const InvisibleArea = styled.div<{ $isOpen: boolean }>`
  width: 100%;
  animation: ${hideTransition} 0.2s ease-out forwards;

  ${({ $isOpen }) =>
    $isOpen &&
    css`
      display: block;
      opacity: 1;
      animation: ${showTransition} 0.2s ease-in forwards;
    `}
`

export const FilterGroupLineStyled = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr auto;
  gap: 10px;
  width: 100%;
  align-items: stretch;

  & > button {
    min-width: 120px;
    white-space: nowrap;
  }
`

export const FilterHeader = styled.div`
  width: 99.5%;
  display: flex;
  justify-content: space-between;
  padding-bottom: 10px;
`

export const FilterActions = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 10px;
`

export const ActionButton = styled.button`
  color: #c7c7c7;
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
  outline: none;
`

export const ToggleButton = styled.button`
  display: flex;
  gap: 2px;
  cursor: pointer;
  color: #c7c7c7;
  background: none;
  border: none;
  padding: 0;
  outline: none;
`

export const ToggleText = styled.span`
  color: #01c38d;
`

export const ToggleIconWrapper = styled.div`
  fill: #01c38d;
  margin-top: 5px;
`
